import { ReactNode, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AdminUserSetup } from './tabs/admin-user-setup';
import { TabNavigation } from '../../../components/tab-navigation/tab-navigation';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import { AdminUserPassword } from './tabs/admin-user-password';
import './admin-user.scss';
import { AdminUserPermissions } from './tabs/admin-user-permissions';
import { AdminUserEmailNotification } from './tabs/admin-user-email-notifications';
import { useAdmin } from '../../../hooks/use-admin-context';
import { useAdminApiV1 } from '../../../clients/quipli-service/admin/admin-api-v1';

export const AdminUser = () => {
  const { getUserAdmin } = useAdminApiV1(),
    { adminUserId, tab } = useParams();

  const adminLogged = useAdmin();
  const adminId = adminUserId && adminUserId.length > 0 ? parseInt(adminUserId) : 0;
  const [activeTab, setActiveTab] = useState<string>(tab && tab.length > 0 ? tab : 'setup'),
    [adminUser, setAdminUser] = useState<Admin>();
  const navigate = useNavigate();
  const tabsRef = useRef<any>(null);

  const profileTabs = [
    {
      id: 'profile',
      name: 'Setup',
      url: `admins/${adminId}/profile`,
    },
    {
      id: 'changePassword',
      name: 'Password',
      url: `admins/${adminId}/changePassword`,
    },
  ];

  const permissionsTabs = [
    {
      id: 'permissions',
      name: 'Permissions',
      url: `admins/${adminId}/permissions`,
    },
    {
      id: 'emails',
      name: 'Emails Settings',
      url: `admins/${adminId}/emails`,
    },
  ];

  function getTabContent(tab: string): ReactNode {
    if (!adminUser) {
      return;
    }

    switch (tab) {
      case 'profile':
        return <AdminUserSetup adminUser={adminUser} />;
      case 'changePassword':
        return <AdminUserPassword adminUser={adminUser} />;
      case 'permissions':
        return <AdminUserPermissions adminUser={adminUser} />;
      case 'emails':
        return <AdminUserEmailNotification adminUser={adminUser} />;
      default:
        return null;
    }
  }

  const init = async () => {
    Promise.all([getUserAdmin(adminId)]).then(([adminUser]) => {
      setAdminUser(adminUser);
    });
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
      if (tabsRef.current?.setTab) {
        tabsRef.current.setTab(tab);
      }
    }
  }, [tab]);

  return (
    <div className="admin-user">
      <div className="container-v2">
        <div onClick={() => navigate('/manager/admins')}>
          <Icon icon="Back" size="large" />
        </div>
        <div className="flex justify-between items-center">
          <Typography type="display-sm" weight="medium">
            Admin User Details
          </Typography>
        </div>

        {adminUser && (
          <TabNavigation
            tabs={adminLogged.id === adminUser.adminId ? permissionsTabs : profileTabs.concat(permissionsTabs)}
            selectedTabName={activeTab}
            onSelect={getTabContent}
            ref={tabsRef}
          />
        )}
      </div>
    </div>
  );
};
